// Quyền trưởng ca gắn theo CA (CEO chốt 27/09/2026 — 1a·2a·3 "dư 2 tiếng
// trước và sau"). Người được xếp làm ca trưởng ở màn Ca vận hành thì, trong
// giờ ca ± 2 tiếng, xem được Bảng suất và đổi gán suất tại đúng cơ sở của ca —
// giữ nguyên vai của mình.
//
// Máy chủ là nơi quyết (`GET /dispatch/lead-now`, orderdispatch/
// shiftlead_power.go). Kho này chỉ giữ câu trả lời gần nhất để menu và màn
// Bảng suất đọc ĐỒNG BỘ — cổng menu (`hasAccess`, nav-content-gates) là hàm
// thường, không gọi hook được. Kho được nạp bởi `useLeadNowSync`
// (features/order-dispatch/api.ts), gắn ở `useSidebarData` nên có mặt trên mọi
// màn sau đăng nhập.

import { create } from "zustand";

export interface ActiveLead {
  branch: string;
  date: string;
  shiftType: "sang" | "chieu";
  /** Lúc hết quyền, ISO 8601. */
  until: string;
}

interface ShiftLeadState {
  leads: ActiveLead[];
  setLeads: (leads: ActiveLead[]) => void;
}

export const useShiftLeadStore = create<ShiftLeadState>((set) => ({
  leads: [],
  setLeads: (leads) => set({ leads }),
}));

/**
 * Các ca còn trong khung quyền tại `now`. Lọc lại theo `until` ở máy khách:
 * câu trả lời nạp lại vài phút một lần, nên hết giờ thì nút phải tắt ngay chứ
 * không chờ lượt nạp sau (máy chủ vẫn từ chối — đây chỉ để màn không nói dối).
 */
export function currentLeads(leads: ActiveLead[] = useShiftLeadStore.getState().leads, now = Date.now()): ActiveLead[] {
  return leads.filter((l) => {
    const t = Date.parse(l.until);
    return Number.isNaN(t) || t > now;
  });
}

/** Người đang đăng nhập có đang là ca trưởng ở cơ sở nào không. */
export function isActiveShiftLead(): boolean {
  return currentLeads().length > 0;
}

/** Ca mà người đang đăng nhập làm ca trưởng tại `branch`, nếu có. */
export function leadAtBranch(branch: string, leads?: ActiveLead[]): ActiveLead | undefined {
  const key = branch.trim().toLowerCase();
  return currentLeads(leads).find((l) => l.branch.trim().toLowerCase() === key);
}

/** "ca sáng" / "ca chiều". */
export function shiftTypeLabel(t: string): string {
  return t === "chieu" ? "ca chiều" : "ca sáng";
}

/** "16:00" — giờ hết quyền theo giờ máy người dùng. */
export function leadUntilLabel(l: ActiveLead): string {
  const d = new Date(l.until);
  if (Number.isNaN(d.getTime())) return "";
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}
